import { Collection } from 'modules/core/lib/mobx-rest'

import Code from 'modules/payroll_integrations/store/models/Code'

class Codes extends Collection<Code> {
  get cacheKey(): string {
    return 'codes'
  }

  model() {
    return Code
  }
}

const singleton: Codes = new Codes()

export default singleton
